/**
 * Money is ALWAYS integer pence inside the system.
 *
 * The prototype stored pounds as floats (`unitCost: 82.5`). That is fine for a
 * localStorage demo and wrong for a product that invoices people: 0.1 + 0.2 is
 * not 0.3, and stock valuation sums thousands of those. Pence in, pence out;
 * format only at the edge.
 */
export function poundsToPence(pounds) {
    return Math.round(pounds * 100);
}
export function penceToPounds(pence) {
    return pence / 100;
}
/** "£1,234" / "£1,234.50" — matches the prototype's `money()` output style. */
export function formatGBP(pence, opts = {}) {
    const showPence = opts.alwaysShowPence === true || pence % 100 !== 0;
    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: showPence ? 2 : 0,
        maximumFractionDigits: showPence ? 2 : 0,
    }).format(penceToPounds(pence));
}
/**
 * Parses user/spreadsheet input ("£82.50", "82.5", "1,234") into pence.
 * Returns null for anything it cannot read, so callers must handle the failure
 * rather than silently importing a zero.
 */
export function parseMoneyToPence(input) {
    if (input === null || input === undefined || input === '')
        return null;
    if (typeof input === 'number')
        return Number.isFinite(input) ? poundsToPence(input) : null;
    const cleaned = input.replace(/[£\s,]/g, '');
    if (cleaned === '' || !/^-?\d*\.?\d+$/.test(cleaned))
        return null;
    const n = Number(cleaned);
    return Number.isFinite(n) ? poundsToPence(n) : null;
}
//# sourceMappingURL=money.js.map